<template>
<div class="vue-group-icon-grabber">
    <aut-icon-passenger-car
            v-if="groupId === 'passenger_car'"
    ></aut-icon-passenger-car>

    <aut-icon-delivery-van
            v-if="groupId === 'delivery_van'"
    ></aut-icon-delivery-van>

    <aut-icon-passenger-bus
            v-if="groupId === 'passenger_bus'"
    ></aut-icon-passenger-bus>

    <aut-icon-trailer
            v-if="groupId === 'trailer'"
    ></aut-icon-trailer>

    <aut-icon-refrigerated-truck
            v-if="groupId === 'refrigerated_truck'"
    ></aut-icon-refrigerated-truck>

    <aut-icon-other
            v-if="groupId === 'other'"
    ></aut-icon-other>

    <aut-icon-other
        v-if="groupId === 'truck'"
    ></aut-icon-other>

    <aut-icon-seasonal-promotion
        v-if="groupId === 'seasonal_promotion'"
    ></aut-icon-seasonal-promotion>
</div>
</template>

<script>
export default {
    name: "GroupIconGrabber",

    props: {
        groupId: {
            type: String,
            required: true,
        }
    }
}
</script>